<template>
    <div class="row g-3 mb-4">
        <!-- NAGŁÓWEK W SPÓJNYM STYLU Z PRZEWIJANIEM -->
        <div ref="headerRef"
            class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer"
            @click="toggleSection">
            <h6 class="fw-bold mb-0">4. Sprzedawca</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <!-- TREŚĆ SEKCJI -->
        <div class="col-12" v-show="sectionCollapse">
            <PartyFormFields v-model="party" :countries="dicts?.countries" :show-gus="true" :show-my-data="true"
                :loading-gus="loadingGus" @fetchGus="fetchGusData" @fetchMyData="handleFetchMyData" />
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import { webAlert } from '@/utils/dialog'
import PartyFormFields from './PartyFormFields.vue'
import apiClient from '@/api'

const props = defineProps({
    modelValue: { type: Object, required: true },
    dicts: { type: Object, default: () => ({ countries: [] }) }
})

const emit = defineEmits(['update:modelValue'])

const headerRef = ref(null)
const sectionCollapse = ref(false)
const loadingGus = ref(false)

const party = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}

const handleFetchMyData = async () => {
    loadingGus.value = true
    try {
        const response = await apiClient.post({ action: 'get-invoice-data' })

        const resData = response.data;

        if (resData?.status === 'success' && resData?.data) {
            const myData = resData.data
            console.log(myData)  // to pokazuja sie dane

            Object.assign(party.value, {
                companyName: myData.companyName || party.value.companyName,
                street: myData.address || party.value.street,
                nip: myData.nip || party.value.nip,
                postalCode: myData.postalCode || party.value.postalCode,
                city: myData.city || party.value.city,
                country: myData.country ? (myData.country === 'POLSKA' ? 'Polska' : myData.country) : party.value.country
            })

        } else if (resData?.message) {
            webAlert(resData)
        } else {
            webAlert('Brak wpisanych danych w sekcji moje dane do faktury.')
        }
    } catch (error) {
        webAlert('Wystąpił błąd podczas pobierania danych.') //ten komunikat sie pojawia
    } finally {
        loadingGus.value = false
    }

}

// Pobieranie i mapowanie danych z GUS
const fetchGusData = async () => {
    const cleanNip = (party.value.nip || '').replace(/[\s-]/g, '')

    if (!/^\d{10}$/.test(cleanNip)) {
        webAlert('Niepoprawny polski numer NIP')
        return
    }

    loadingGus.value = true
    try {
        const response = await apiClient.post(
            {
                action: 'get_data_from_gus',
                nip: cleanNip
            }
        )

        const resData = response.data

        if (resData?.type === 'success' && resData?.data) {
            const gus = resData.data

            // Mapowanie zwróconych pól GUS na pola obiektu formularza
            Object.assign(party.value, {
                companyName: gus.name || party.value.companyName,
                street: gus.address || party.value.street,
                postalCode: gus.zipcode || party.value.postalCode,
                city: gus.city || party.value.city,
                country: gus.country ? (gus.country === 'POLSKA' ? 'Polska' : gus.country) : party.value.country
            })

        } else if (resData?.message) {
            webAlert(resData)
        } else {
            webAlert('Nie znaleziono firmy o podanym numerze NIP.')
        }
    } catch (error) {
        console.error('Błąd podczas pobierania danych z GUS:', error)
        webAlert('Wystąpił błąd podczas połączenia z API GUS.')
    } finally {
        loadingGus.value = false
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>